/**
 * Determines if the current page is in an iframe element.
 *
 * @return bool True if the frame is in an iframe; otherwise, false.
 */
export function isInIframe() {
  return (window?.location !== window?.parent?.location)
}
